import { takeArgumentN } from "../fpUtils";
import { isArrayItemsVaried } from "../arrayUtils";

export * from "./distributeByFns";
export * from "./compouseWariations";
export * from "./stateTravel";
export * from "./fnArguments";

/*
 */
export function noopFn() {}

/*
 */
export function nullFn() {
    return null;
}

/*
 */
export const attemptFn = <F extends (...a: any[]) => any>(fn: F) => (
    ...args: Parameters<F>
): ReturnType<F> => (typeof fn === "function" ? fn(...args) : undefined);

/*
memoizeOne
 */
export const memoizeOne = <T, Args extends any[] = any[]>(
    fn: (...args: Args) => T,
    resolve = takeArgumentN(0),
    isSame = (a, b) => a === b
): ((...args) => T) => {
    let memoKey,
        memoValue,
        // when first arg is undefined then there is no fn call, but it should be
        notCalled = true;

    return (...args: Args) => {
        const key = resolve(...args);
        if (!isSame(memoKey, key) || notCalled) {
            memoKey = key;
            memoValue = fn(...args);
            notCalled = false;
        }
        return memoValue as T;
    };
};

/*
memoize
 */
export const memoize = <T>(
    fn: (...args) => T,
    resolve = takeArgumentN(0)
): ((...args) => T) => {
    const bag = {};

    return (...args) => {
        const key = resolve(...args);
        if (typeof key == "object")
            throw new Error(
                "memoize() may use only primitive data types as keys"
            );

        return bag.hasOwnProperty(key) ? bag[key] : (bag[key] = fn(...args));
    };
};

export function memoOnceArgs<F extends (...args: any[]) => any>(f: F): F {
    let store, storedArgs;
    function m(...args) {
        if (!storedArgs || isArrayItemsVaried(storedArgs, args)) {
            store = f(...args);
            storedArgs = args;
        }
        return store;
    }
    return m as F;
}
